import { gql } from '@apollo/client';

export const readAllUsers = gql`
  {
    readAllApplicationUsers {
      id
      name
    }
  }
`;
export const createVerifications = gql`
  mutation syncScans($verifications: [VerificationInput!]!, $userDepartmentId: Float!) {
    syncScans(scans: $verifications, userDepartmentId: $userDepartmentId)
  }
`;
